/**
 * Endereço para roteirização no encaminhar chamado (Board → agenda Open OS v2).
 */

function pickOrderCity(order) {
  return String(order?.cidade || order?.TB02115_CIDADE || '').trim();
}

function pickOrderState(order) {
  return String(order?.estado || order?.TB02115_ESTADO || '').trim();
}

function pickOrderStreet(order) {
  return String(order?.endereco || order?.TB02115_ENDERECO || order?.ENDERECO || '').trim();
}

/** Monta endereço completo para geocodificação (mesmo padrão do modal de detalhes). */
export function getBoardOrderRouteHelpAddress(order) {
  const endereco = pickOrderStreet(order);
  const cidade = pickOrderCity(order);
  const estado = pickOrderState(order);

  if (!endereco && !cidade) return '';

  let enderecoCompleto = endereco || cidade;
  if (cidade && endereco && !enderecoCompleto.toLowerCase().includes(cidade.toLowerCase())) {
    enderecoCompleto += `, ${cidade}`;
  }
  if (estado && !enderecoCompleto.toLowerCase().includes(estado.toLowerCase())) {
    enderecoCompleto += `, ${estado}`;
  }
  if (enderecoCompleto && !enderecoCompleto.toLowerCase().includes('brasil')) {
    enderecoCompleto += ', Brasil';
  }
  return enderecoCompleto;
}

export function getBoardOrderRouteHelpCity(order) {
  return pickOrderCity(order);
}

/**
 * Resolve endereço da primeira OS com endereço utilizável.
 * @param {string[]} orderIds
 * @param {(id: string) => { order?: object } | object | null} resolveOrder
 */
export function resolveBoardEncaminharRouteOrigin(orderIds, resolveOrder) {
  const ids = Array.isArray(orderIds) ? orderIds : [];
  for (const rawId of ids) {
    const id = String(rawId ?? '').trim();
    if (!id) continue;
    const found = typeof resolveOrder === 'function' ? resolveOrder(id) : null;
    const order = (found && found.order) || found;
    const address = getBoardOrderRouteHelpAddress(order);
    if (address) {
      return { address, city: getBoardOrderRouteHelpCity(order) };
    }
  }
  return { address: '', city: '' };
}
